'use client';

import BodyLink from '@jouzen/ecom-components/v3/BodyLink';
import { useLocale } from 'next-intl';
import type { ReactNode } from 'react';
import React from 'react';

import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import RichText from '../RichText';

export default function BatteryAndTipsFootnote() {
  const locale = useLocale();
  const localePartialUrl = getLocalePartialUrl(locale);

  const batteryAndTipsTValues = {
    battery: (chunks: ReactNode) => (
      <BodyLink
        className="text-current"
        href={`https://support.ouraring.com/hc${localePartialUrl}articles/35694051065235-Oura-Ring-4-Battery-Life`}
        target="_blank"
      >
        {chunks}
      </BodyLink>
    ),
    tips: (chunks: ReactNode) => (
      <BodyLink
        className="text-current"
        href={`https://support.ouraring.com/hc${localePartialUrl}articles/360046218953-Ring-Battery-Tips`}
        target="_blank"
      >
        {chunks}
      </BodyLink>
    ),
  };

  return (
    <RichText
      messageKey="ring_pdp_2025_battery_disclaimer"
      tValues={batteryAndTipsTValues}
    />
  );
}
